module.exports = __webpack_public_path__ + "static/media/laptop-books.9d7c2fde.png";